import { Chat } from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  Divider,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Typography,
  IconButton
} from '@mui/material';
import { MIconButton } from 'components/@material-extend';
import MenuPopover from 'components/MenuPopover';
import Scrollbar from 'components/Scrollbar';
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import clockFill from '@iconify/icons-eva/clock-fill';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getNewChatData } from 'redux/slices/chat';
import moment from 'moment';
import DashboardChatBox from 'components/_dashboard/dashboardChatBox/DashboardChatBox';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CircularProgress } from '@mui/material';
import useLocales from 'hooks/useLocales';
import { Stack } from '@mui/material';
import { Chip } from '@mui/material';
import { Tooltip } from '@mui/material';

const ChatPopOver = () => {
  const dispatch = useDispatch();
  const { appointmentDetails, isLoading } = useSelector((state: RootState) => state?.appointment);
  const { myProfile } = useSelector((state: RootState) => state.user);
  const { adminAllMessages } = useSelector((state: RootState) => state.chat);

  const [openChatBox, setOpenChatBox] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);
  const [presistMessage, setPresistMessage] = useState<any>({
    oldMessages: [],
    recentMessages: []
  });
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(15);
  const [referenceId, setReferenceId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('Fetching page:', page);
    dispatch(getNewChatData(page, size));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  useEffect(() => {
    if (adminAllMessages?.result) {
      setPresistMessage((prev: any) => ({
        recentMessages:
          page === 1
            ? adminAllMessages?.result?.recentMessages ?? []
            : [...prev.recentMessages, ...(adminAllMessages?.result?.recentMessages ?? [])],
        oldMessages:
          page === 1
            ? adminAllMessages?.result?.oldMessages ?? []
            : [...prev.oldMessages, ...(adminAllMessages?.result?.oldMessages ?? [])]
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminAllMessages]);

  const handleOpen = () => {
    setLoading(true);
    dispatch(
      getNewChatData(page, size, (data: any) => {
        if (data?.data?.status) {
          setLoading(false);
        }
      })
    );
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenChatBox(false);
    setSelectedNotification(null);
  };

  const handleNotificationClick = (notification: any) => {
    setSelectedNotification(notification);
    setOpenChatBox(true);
    dispatch(
      getNewChatData(page, size, (data: any) => {
        if (data?.data?.status) {
        }
      })
    );
  };

  const handleBackButtonClick = () => {
    setOpenChatBox(false);
    setSelectedNotification(null);
  };

  const NextPage = () => {
    const total = adminAllMessages?.result?.totalCount ?? 0;
    const currentLength =
      presistMessage?.recentMessages?.length + presistMessage?.oldMessages?.length;

    if (currentLength < total) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (selectedNotification?.referenceTypeId === 'Appointment') {
      setReferenceId('0');
    } else if (selectedNotification?.referenceTypeId === 'MasterRequestApproved') {
      setReferenceId('2');
    } else if (selectedNotification?.referenceTypeId === 'MasterRequest') {
      setReferenceId('1');
    } else if (selectedNotification?.referenceTypeId === 'GeneralChat') {
      setReferenceId('5');
    } else if (selectedNotification?.referenceTypeId === 'Bid') {
      setReferenceId('3');
    } else if (selectedNotification?.referenceTypeId === 'Demo') {
      setReferenceId('4');
    }
  }, [selectedNotification]);

  const allMessagesLength =
    presistMessage.recentMessages.length + presistMessage.oldMessages.length;

  const totalCount = adminAllMessages?.result?.totalCount ?? 0;

  console.log(allMessagesLength, 'allMessagesLength', totalCount);
  function NotificationItem({ notification }: { notification: any }) {
    const { currentLang } = useLocales();
    moment.locale(currentLang.value);
    const formattedDate = moment(notification?.lastMessageDate).format('YYYY-MM-DD hh:mm A');

    return (
      <ListItemButton
        onClick={() => handleNotificationClick(notification)}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(!notification.isRead && {
            bgcolor: 'action.selected'
          })
        }}
      >
        <ListItemAvatar>
          <Badge
            badgeContent={notification?.unReadMsgCount > 9 ? '9+' : notification?.unReadMsgCount}
            color="error"
            invisible={notification?.unReadMsgCount <= 0}
            overlap="circular"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.7rem',
                fontWeight: 'bold',
                minWidth: '18px',
                height: '18px'
              }
            }}
          >
            <Avatar sx={{ bgcolor: 'background.neutral' }} />
          </Badge>
        </ListItemAvatar>

        <ListItemText
          primary={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                width: '100%'
              }}
            >
              {/* Username with tooltip */}
              <Tooltip title={notification?.fromUserName || ''} placement="top">
                <Typography
                  component="span"
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '180px'
                  }}
                >
                  {notification?.fromUserName?.length > 18
                    ? notification?.fromUserName.slice(0, 15) + '...'
                    : notification?.fromUserName}
                </Typography>
              </Tooltip>

              {/* Badges */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                {notification?.referenceTypeId && (
                  <Chip
                    label={notification?.referenceTypeId}
                    size="small"
                    color="primary"
                    sx={{ fontSize: '0.7rem', height: 20 }}
                  />
                )}
                {notification?.statusName && (
                  <Chip
                    label={notification?.statusName}
                    size="small"
                    sx={{
                      fontSize: '0.7rem',
                      height: 20,
                      bgcolor:
                        notification?.statusName === 'Closed'
                          ? 'error.main'
                          : notification?.statusName === 'Expired'
                          ? 'orange'
                          : 'success.main',
                      color: 'white'
                    }}
                  />
                )}
              </Box>
            </Box>
          }
          secondary={
            <>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  color: 'text.disabled'
                }}
              >
                {moment(formattedDate).locale('en').format('DD/MM/YYYY dddd, h:mm A')}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  color: 'text.disabled'
                }}
              >
                {notification?.referenceNumber}
              </Typography>
            </>
          }
        />
      </ListItemButton>
    );
  }

  return (
    <>
      <MIconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
      >
        <Badge
          badgeContent={adminAllMessages?.result?.unReadMsgCount}
          color="primary"
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <Chat />
        </Badge>
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360, height: 560 }}
      >
        {openChatBox ? (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
              <IconButton onClick={handleBackButtonClick} sx={{ mr: 1 }}>
                <Box component={Icon} icon="eva:arrow-back-fill" />
              </IconButton>
              {/* Show chat information */}
            </Box>
            <DashboardChatBox
              statusName={selectedNotification?.statusName}
              userId={selectedNotification?.toUserId}
              id={selectedNotification?.referenceId}
              toUserId={selectedNotification?.fromUserId}
              type={Number(referenceId)}
              openChatBox={openChatBox}
              closeChatBox={() => setOpenChatBox(false)}
              createdDate={selectedNotification?.createdDate}
              referenceNumber={selectedNotification?.referenceNumber}
            />
          </>
        ) : (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
              <Typography variant="subtitle1">Conversations</Typography>
            </Box>
            <Divider />
            {loading ? (
              <Stack
                sx={{
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <CircularProgress />
              </Stack>
            ) : (
              <>
                <Box id="scrollableSidebarBox" style={{ height: '500px', overflow: 'auto' }}>
                  {' '}
                  {/* Increased height */}
                  <InfiniteScroll
                    dataLength={allMessagesLength}
                    next={NextPage}
                    hasMore={allMessagesLength < (adminAllMessages?.result?.totalCount ?? 0)}
                    scrollableTarget="scrollableSidebarBox"
                    loader={
                      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                        <CircularProgress size={24} />
                      </Box>
                    }
                  >
                    <List
                      disablePadding
                      subheader={
                        <ListSubheader
                          disableSticky
                          sx={{ py: 1, px: 2.5, typography: 'overline' }}
                        >
                          New
                        </ListSubheader>
                      }
                    >
                      {presistMessage.recentMessages
                        .filter((n: any) => !n.isRead)
                        .map((data: any) => (
                          <NotificationItem key={data.userId} notification={data} />
                        ))}
                    </List>
                    <List
                      disablePadding
                      subheader={
                        <ListSubheader
                          disableSticky
                          sx={{ py: 1, px: 2.5, typography: 'overline' }}
                        >
                          Old
                        </ListSubheader>
                      }
                    >
                      {presistMessage.oldMessages
                        .filter((n: any) => !n.isRead)
                        .map((data: any) => (
                          <NotificationItem key={data.userId} notification={data} />
                        ))}
                    </List>
                  </InfiniteScroll>
                </Box>
              </>
            )}
          </>
        )}
      </MenuPopover>
    </>
  );
};

export default ChatPopOver;
